"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetFacade_1 = require("auto-widget-framework/src/Widget/WidgetFacade");
const InchcapeInternalEvents_1 = require("../Enum/InchcapeInternalEvents");
class PXWidgetFacade extends WidgetFacade_1.default {
    /**
     * @inheritDoc
     */
    static getRestrictedEvents() {
        return super.getRestrictedEvents()
            .concat(Object.values(InchcapeInternalEvents_1.InchcapeInternalEvents));
    }
    /**
     * Gets the valuation.
     */
    getValuation() {
        return this.widgetState.get("valuation");
    }
}
exports.default = PXWidgetFacade;
